<div class="p-4 bg-white shadow-lg rounded-2xl h-full w-full">
  <ng-content />
</div>
